import { Component } from '@angular/core';
import {IonicPage, NavController, Platform} from 'ionic-angular';
import {DataProvider} from "../../providers/data/data";
import {Photo} from "../../models/data.model";
import {PhotosViewerPage} from "../photos-viewer/photos-viewer";


@IonicPage()
@Component({
  selector: 'page-environmental-alert',
  templateUrl: 'environmental-alert.html',
})
export class EnvironmentalAlertPage {

  constructor(public data: DataProvider, public navCtrl: NavController, public platform: Platform) {
  }

  protected getEnvironmentalAlert(): string {
    return (this.data.getEnvironmentalAlertContent() !== null) ? this.data.getEnvironmentalAlertContent().text : "";
  }

  protected clickText(event: Event) {
    console.log(event);
    const element: HTMLElement = <HTMLElement>event.target;
    if (element.nodeName != "IMG") return;
    const photo: Photo = {
      name: "photo",
      url: (<HTMLImageElement>element).src
    };
    this.navCtrl.push(PhotosViewerPage, {
      photos: [photo]
    }).catch();
  }

}



// WEBPACK FOOTER //
// ./src/pages/environmental-alert/environmental-alert.ts